import { CircularProgress, Button, Grid, Typography, TextField, Box, Hidden, Card, CardContent
    , FormControl, InputLabel, Input, Select, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Search as IconSearch, Add as IconAdd, HourglassEmpty as IconHourglassEmpty
    , CheckCircleOutline as IconCheckCircleOutline, Dangerous as IconDangerous } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as periodoService from "../../services/periodoService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbarContainer, GridOverlay
    , GridToolbarFilterButton } from "@mui/x-data-grid";
import { setValue, setListTerapiasParticipantes, setListFilial, setListPeriodos
    , setValidationMessage, activeValidations
    , setListTiposTerapias, setListEstados, setDataTerapiasParticipantes } from '../../redux/therapyPeriodOpenSlice';
import DialogYesNo from '../../components/DialogYesNo'
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { FormHelperText as HelperText } from '@mui/material';

const Open = () => {
    const { isReadOnly } = useMantenimiento(["terapiaPeriodo.abrir", "terapiaPeriodo"]);
    const input = useSelector((state) => state.therapyPeriodOpen.input);
    const listTerapiasParticipantes = useSelector((state) => state.therapyPeriodOpen.listTerapiasParticipantes);
    const listFilial = useSelector((state) => state.therapyPeriodOpen.listFilial);
    const listPeriodos = useSelector((state) => state.therapyPeriodOpen.listPeriodos);
    const listTiposTerapias = useSelector((state) => state.therapyPeriodOpen.listTiposTerapias);
    const listEstados = useSelector((state) => state.therapyPeriodOpen.listEstados);
    const validationMessage = useSelector((state) => state.therapyPeriodOpen.validationMessage);
    const validate = useSelector((state) => state.therapyPeriodOpen.validationActive);
    const [openDialogGenerate, setOpenDialogGenerate] = useState(false)
    const openCloseDialogGenerate = () => { setOpenDialogGenerate(!openDialogGenerate); }
    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const [cargando, setCargando] = useState(false);
    const [isFiltering, setIsFiltering] = useState(false);
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    var validation = {
        idFilial: {
            error: input.idFilial == null || input.idFilial == 0,
            message: "Falta seleccionar la Filial",
        },
        idPeriodo: {
            error: input.idPeriodo == null || input.idPeriodo == 0,
            message: "Falta seleccionar el Periodo",
        },
        atLeastOneTherapy: {
            error: listTerapiasParticipantes == null || listTerapiasParticipantes.length == 0,
            message: "Deben listarse las terapias para la generacion",
        }
    }
    const fetchTerapiasParticipantes = async () => {
        setCargando(true);

        await terapiaService.getsTerapiaParticipanteResumenView(input)
            .then(async (data) => {
                // Solo se listan las terapias que aun no tienen periodo abierto
                // en el periodo elegido: las que ya lo tienen no se repiten.
                // Las que ya estan abiertas salen del listado de periodos de
                // terapia de ese mismo periodo.
                const idPeriodo = input.idPeriodo == null ? 0 : parseInt(input.idPeriodo);

                let yaAbiertas = [];

                if (idPeriodo > 0) {
                    yaAbiertas = await terapiaService.getsTerapiaPeriodoResumenView({
                        idPeriodo: idPeriodo,
                        idFilial: 0,
                        idTipoTerapia: 0,
                        participante: "",
                        idTerapeuta: 0,
                        terapeuta: "",
                        idEstado: 0,
                        idTerapiaPeriodo: 0,
                    }).catch(() => []);
                }

                const abiertas = new Set((yaAbiertas || []).map((row) => row.idTerapia + "-" + row.numero));

                const pendientes = idPeriodo > 0
                    ? (data || [])
                        .filter((row) => !abiertas.has(row.idTerapia + "-" + row.numero))
                        .map((row) => ({ ...row, id: row.idParticipante }))
                    : [];

                dispatch(setListTerapiasParticipantes(pendientes));
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchFilial = async () => {
        await filialService.getFilialesList()
            .then((data) => {
                dispatch(setListFilial(filialService.soloFilialDelUsuario(data, idFilialUsuario)));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchPeriodos = async (idFilial) => {
        if (!idFilial || idFilial <= 0) {
            dispatch(setListPeriodos([]));
            return;
        }
        await periodoService.getsPeriodoView({
                idFilial: idFilial,
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
                idCategoria: 67,
            })
            .then((data) => {
                const lista = data || [];
                dispatch(setListPeriodos(lista));
                if (lista.length === 1) {
                    dispatch(setValue({ name: "idPeriodo", value: lista[0].id }));
                }
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }
    const fetchTiposTerapias = async () => {
        await catalogoService.getCatalogosByPadre(49)
            .then((data) => {
                dispatch(setListTiposTerapias(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                // dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fecthGenerarTerapiasPeriodos = async () => {
        dispatch(activeValidations());
        dispatch(setValidationMessage(messagesValidation()));

        if (validationMessage != "") {
            setPropsMessage({ severity: "error", message: validationMessage })
            setOpenMessage(true);
        }
        else {
            var i = 0;

            // El periodo seleccionado se muestra con su codigo en el comprobante.
            const periodo = (listPeriodos || []).find((row) => row.id == input.idPeriodo);

            // Se genera el periodo de terapia de cada terapia listada. El comprobante
            // ya no se emite aqui: se registra desde la navegabilidad de los periodos
            // de terapia, con la opcion "Registrar" de la columna Pago.
            while (i < listTerapiasParticipantes.length) {
                var id = listTerapiasParticipantes[i].id;

                await terapiaService.addTerapiaPeriodo(
                    input.idPeriodo,
                    listTerapiasParticipantes[i].idTerapia,
                    listTerapiasParticipantes[i].numero,
                    listTerapiasParticipantes[i].idTarifa,
                    listTerapiasParticipantes[i].idPersona,
                    periodo?.codigo,
                    listTerapiasParticipantes[i].participante,
                    listTerapiasParticipantes[i].idDescuento,
                    listTerapiasParticipantes[i].montoDescuento
                )
                    .then((response) => {
                        // Si el periodo ya existia se avisa que no se genero de nuevo.
                        const data = response && response.data ? response.data.data : null;

                        if (data && data.existia) {
                            dispatch(setDataTerapiasParticipantes({ id: id, name: "estadoCreacion", value: "E" }));

                            return;
                        }

                        dispatch(setDataTerapiasParticipantes({ id: id, name: "estadoCreacion", value: "O" }));
                    })
                    .catch((err) => {
                        dispatch(setDataTerapiasParticipantes({ id: id, name: "estadoCreacion", value: "E" }));

                        console.log("Err: ", err);
                    });

                i++;
            }

            setPropsMessage({ severity: "success", message: "Se generaron los periodos de terapia. Registre el pago desde la navegabilidad de Periodos de Terapia." })
            setOpenMessage(true);

            // Con la generacion hecha, los filtros vuelven a estar disponibles: ya
            // se pueden elegir otra filial, otro periodo u otro tipo de terapia.
            setIsFiltering(false);
        }
    }

    useEffect(() => {
        // La ventana siempre se muestra limpia: se restablecen los filtros y el
        // listado de terapias de la apertura anterior.
        setIsFiltering(false);
        const fInicial = idFilialUsuario > 0 ? idFilialUsuario : 0;
        dispatch(setValue({ name: "idFilial", value: fInicial }));
        dispatch(setValue({ name: "idPeriodo", value: 0 }));
        dispatch(setValue({ name: "idTipoTerapia", value: 0 }));
        dispatch(setListTerapiasParticipantes([]));

        fetchFilial();
        if (fInicial > 0) {
            fetchPeriodos(fInicial);
        }
        fetchTiposTerapias();
        fetchEstados();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [input, listTerapiasParticipantes])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const columns = [
        { field: 'estadoCreacion', headerName: '', width: 50, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return cellValues.row.estadoCreacion == "P" ? <IconHourglassEmpty /> : (cellValues.row.estadoCreacion == "O" ? <IconCheckCircleOutline /> : (cellValues.row.estadoCreacion == "E" ? <IconDangerous /> : null ))
            }
                // return <IconButton aria-label="creado" size='small' style={{height: 10}} align={"center"} onClick={() => {
                //     setSelectId(cellValues.row.id);
                //     setSelectState(cellValues.row.estado);
                //     setOpenDialogAnnulActive(true);
                // }}>
                //     { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                // </IconButton>;
        },
        { field: 'participante', headerName: 'Participante', width: 180, sortable: false, headerAlign: 'center' },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 180, sortable: false, headerAlign: 'center' },
        { field: 'tipoTerapia', headerName: 'Tipo Terapia', width: 100, sortable: false, headerAlign: 'center' },
        // { field: 'estadoTerapia', headerName: 'Estado Terapia', width: 80, sortable: false, headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center' },
    ];

    function CustomToolbar() {
        // El botÃ³n GENERAR siempre muestra "Generar", nunca "Cancelar"
        // "Cancelar" solo aparece en el botÃ³n FILTRO cuando hay filtros activos
        const buttonDisabled = isReadOnly;

        return (
            <GridToolbarContainer>
                <Button size="small" disabled={buttonDisabled} onClick={() => setOpenDialogGenerate(true)}>
                    Generar
                    <IconAdd />
                </Button>
            </GridToolbarContainer>
        );
    }

    function CustomLoadingOverlay() {
        return (
            <GridOverlay>
                <div xs={{
                    display: 'flex',
                    '& > * + *': {
                        ml: 2
                    },
                }}>
                    <CircularProgress />
                </div>
            </GridOverlay>
        );
    }

    const [selectItem, setSelection] = useState([]);

    return (
        <div>
            {/* {JSON.stringify(selectItem)} */}
            <Grid container spacing={0}>
                <Grid item xs={6} sm={6}>
                    <Typography variant="h5" component="span">
                        <Box sx={{ fontWeight: 'bold' }}>
                            Aperturar Periodos de Terapia
                        </Box>
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                <Box textAlign='right'>
                    <Link to={'/therapyperiod'} >{"Volver"}</Link>
                </Box>
                </Grid>
            </Grid>
            
            {/* El contenedor lleva spacing para que la tarjeta de filtros no quede
                pegada a la lista de debajo. */}
            <Grid container spacing={1} sx={{ "& > .MuiGrid-item": { paddingTop: "12px" } }}>
                <Grid item>
                    <Card>
                        <CardContent sx={{ padding: "10px 10px 10px 10px !important" }}>
                            <Grid container item xs={12} sm={12} spacing={1}
                                sx={{ "& > .MuiGrid-item": { paddingTop: "10px" } }}>
                                <Grid item xs={6} sm={4}>
                                    <FormControl required fullWidth error={validate.idFilial && validation.idFilial.error}>
                                        <InputLabel htmlFor="input-filial">Filial</InputLabel>
                                        <Select
                                            native
                                            label="Filial"
                                            value={input.idFilial}
                                            onChange={(event) => {
                                                const nuevaFilial = parseInt(event.target.value) || 0;
                                                dispatch(setValue({name: "idFilial", value: nuevaFilial}));
                                                dispatch(setValue({name: "idPeriodo", value: 0}));

                                                if (nuevaFilial > 0) {
                                                    fetchPeriodos(nuevaFilial);
                                                } else {
                                                    dispatch(setListPeriodos([]));
                                                }
                                            }}
                                            inputProps={{
                                                name: 'idFilial',
                                                id: 'input-filial',
                                            }}
                                            size="small"
                                            disabled={isFiltering || idFilialUsuario > 0}
                                        >
                                            {idFilialUsuario <= 0 && <option key={0} value={0}>{"(Seleccione)"}</option>}
                                            {listFilial.map((row) => (
                                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                                            ))}
                                        </Select>
                                        <HelperText>
                                            {validate.idFilial && validation.idFilial.error ? validation.idFilial.message : ""}
                                        </HelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <FormControl required fullWidth error={validate.idPeriodo && validation.idPeriodo.error}>
                                        <InputLabel htmlFor="input-periodo">Periodo</InputLabel>
                                        <Select
                                            native
                                            label="Periodo"
                                            value={input.idPeriodo || 0}
                                            onChange={(event) => {
                                                dispatch(setValue({name: "idPeriodo", value: parseInt(event.target.value) || 0}))
                                            }}
                                            inputProps={{
                                                name: 'idPeriodo',
                                                id: 'input-periodo',
                                            }}
                                            size="small"
                                            disabled={isFiltering}
                                        >
                                            <option key={0} value={0}>{"(Seleccione)"}</option>
                                            {listPeriodos.map((row) => (
                                                <option key={row.id} value={row.id}>{row.codigo}</option>
                                            ))}
                                        </Select>
                                        <HelperText>{validate.idPeriodo && validation.idPeriodo.error ? validation.idPeriodo.message : ""}</HelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                                        <Select
                                            native
                                            label="Tipo Terapia"
                                            value={input.idTipoTerapia}
                                            onChange={(event) => {
                                                dispatch(setValue({name: "idTipoTerapia", value: event.target.value}))
                                            }}
                                            inputProps={{
                                                name: 'idTipoTerapia',
                                                id: 'input-tipoterapia',
                                            }}
                                            size="small"
                                            disabled={isFiltering}
                                        >
                                            <option key={0} value={0}>{"(Todos)"}</option>
                                            {listTiposTerapias.map((row) => (
                                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Button variant="outlined" size="small" onClick={() => {
                                        if (!isFiltering) {
                                            if (input.idFilial > 0 && input.idPeriodo > 0) {
                                                setIsFiltering(true);
                                                // Aplicar filtro: obtener terapias con los filtros actuales
                                                fetchTerapiasParticipantes();
                                            } else {
                                                // Mostrar error si falta filial o periodo
                                                setPropsMessage({ severity: "error", message: "Seleccione la Filial y el Periodo antes de filtrar" });
                                                setOpenMessage(true);
                                            }
                                        } else {
                                            setIsFiltering(false);
                                            const fInicial = idFilialUsuario > 0 ? idFilialUsuario : 0;
                                            dispatch(setValue({name: "idFilial", value: fInicial}));
                                            dispatch(setValue({name: "idPeriodo", value: 0}));
                                            dispatch(setValue({name: "idTipoTerapia", value: 0}));
                                            dispatch(setListTerapiasParticipantes([]));
                                        }
                                    }}>
                                        {isFiltering ? "Cancelar" : "Filtrar"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                        <DataGrid
                            rows={listTerapiasParticipantes}
                            columns={columns}
                            initialState={{
                                pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                                },
                            }}
                            pageSize={10}
                            pageSizeOptions={[10]}
                            disableColumnMenu
                            components={{
                                LoadingOverlay: CustomLoadingOverlay,
                            }}
                            slots={{
                                toolbar: CustomToolbar,
                            }}
                            loading={cargando}
                            rowHeight={25}
                            onRowSelectionModelChange={(itm) => setSelection(itm)}
                            xs={{
                                "& .MuiDataGrid-columnHeader ": {
                                    backgroundColor: "#1976d2",
                                    color: "white"
                                }
                            }}
                            autoHeight={true}
                            sx={{
                            '& .MuiDataGrid-cell:hover': {
                                color: 'primary.main',
                            },
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{vertical: "top", horizontal: "center"}}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                {propsMessage.message}
                </Alert>
            </Snackbar>
            <FormControl required fullWidth
                error={
                    (validate.atLeastOneTherapy && validation.atLeastOneTherapy.error)
                }>
                <HelperText>
                    {validate.atLeastOneTherapy && validation.atLeastOneTherapy.error ? validation.atLeastOneTherapy.message : ""}
                </HelperText>
            </FormControl>
            <DialogYesNo
                open={openDialogGenerate}
                openClose={openCloseDialogGenerate}
                setYes={fecthGenerarTerapiasPeriodos}
                setNo={() => { return }}
                titulo={"Generar Periodos para Terapias"}
                texto={"Esta seguro de generar los Periodos para las Terapias?"}
            ></DialogYesNo>
        </div>
    )
}
export default Open
